<template>
  <div class="start-page">
    <h2>设备检测向导</h2>
    <p class="normal-text">为保证考试顺利进行，请配合完成如下测试吧～</p>
    <ul class="flex-row-center">
      <li class="flex-column-center" v-show="detectTypes.includes(1)">
        <p class="icon-wrap flex-row-center"><icon-pc class="icon-pc"></icon-pc></p>
        <h3>网络与设备检测</h3>
      </li>
      <li class="circle-wrap flex-content-between" v-show="detectTypes.includes(1) && detectTypes.includes(2)">
        <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      </li>
      <li class="flex-column-center" v-show="detectTypes.includes(2)">
        <p class="icon-wrap flex-row-center"><icon-camera class="icon-camera"></icon-camera></p>
        <h3>摄像头检测</h3>
      </li>
      <li class="circle-wrap flex-content-between" v-show="detectTypes.length > 1 && detectTypes.includes(3)">
        <span></span><span></span><span></span><span></span><span></span><span></span><span></span>
      </li>
      <li class="flex-column-center" v-show="detectTypes.includes(3)">
        <p class="icon-wrap flex-row-center"><icon-micro class="icon-micro"></icon-micro></p>
        <h3>麦克风检测</h3>
      </li>
    </ul>
    <button type="button" @click="start">开始检测</button>
  </div>
</template>

<script>
import IconPc from '@/assets/svg/detect/icon_pc.svg'
import IconCamera from '@/assets/svg/detect/icon_camera.svg'
import IconMicro from '@/assets/svg/detect/icon_micro.svg'
export default {
  components: {
    IconPc,
    IconCamera,
    IconMicro
  },
  props: {
    detectTypes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    start() {
      this.$emit('nextStep', 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .start-page {
    padding-bottom: 75px;
  }
  .normal-text {
    color: #333;
    margin: 15px 0 65px 0;
    font-weight: 400;
  }
  .icon-wrap {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 1px solid rgba(48, 111, 255, 0.3);
    margin-bottom: 10px;
  }
  .icon-pc {
    width: 50px;
    height: 39px;
  }
  .icon-camera {
    width: 40px;
    height: 51px;
  }
  .icon-micro {
    width: 34px;
    height: 51px;
  }
  .circle-wrap {
    width: 76px;
    margin: -26px 32px 0 32px;
    span {
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: linear-gradient(270deg,rgba(59,141,255,1) 0%,rgba(48,111,255,1) 100%);
      box-shadow: 0 4px 4px 0 rgba(48,111,255,0.4);
    }
  }
  button {
    @include theme-fill-btn(144px, 42px, 16px, 4px);
    margin-top: 75px;
  }
</style>
